import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import 'react';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { COLOR_CODE } from '../../constants/ui.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "icon": "web_ui__Icon__icon",
  "block": "web_ui__Icon__block",
  "parent": "web_ui__Icon__parent",
  "primary-default": "web_ui__Icon__primary-default",
  "primary-medium": "web_ui__Icon__primary-medium",
  "primary-extra-light": "web_ui__Icon__primary-extra-light",
  "primary-light": "web_ui__Icon__primary-light",
  "primary-dark": "web_ui__Icon__primary-dark",
  "primary-extra-dark": "web_ui__Icon__primary-extra-dark",
  "success-default": "web_ui__Icon__success-default",
  "success-medium": "web_ui__Icon__success-medium",
  "success-extra-light": "web_ui__Icon__success-extra-light",
  "success-light": "web_ui__Icon__success-light",
  "success-dark": "web_ui__Icon__success-dark",
  "success-extra-dark": "web_ui__Icon__success-extra-dark",
  "expose-default": "web_ui__Icon__expose-default",
  "expose-medium": "web_ui__Icon__expose-medium",
  "expose-extra-light": "web_ui__Icon__expose-extra-light",
  "expose-light": "web_ui__Icon__expose-light",
  "expose-dark": "web_ui__Icon__expose-dark",
  "expose-extra-dark": "web_ui__Icon__expose-extra-dark",
  "warning-default": "web_ui__Icon__warning-default",
  "warning-medium": "web_ui__Icon__warning-medium",
  "warning-extra-light": "web_ui__Icon__warning-extra-light",
  "warning-light": "web_ui__Icon__warning-light",
  "warning-dark": "web_ui__Icon__warning-dark",
  "warning-extra-dark": "web_ui__Icon__warning-extra-dark",
  "muted-default": "web_ui__Icon__muted-default",
  "amplified-default": "web_ui__Icon__amplified-default",
  "greyscale-level-1": "web_ui__Icon__greyscale-level-1",
  "greyscale-level-2": "web_ui__Icon__greyscale-level-2",
  "greyscale-level-3": "web_ui__Icon__greyscale-level-3",
  "greyscale-level-4": "web_ui__Icon__greyscale-level-4",
  "greyscale-level-5": "web_ui__Icon__greyscale-level-5",
  "greyscale-level-6": "web_ui__Icon__greyscale-level-6",
  "foreground-action-primary-prominent-high-idle": "web_ui__Icon__foreground-action-primary-prominent-high-idle",
  "foreground-action-primary-prominent-idle": "web_ui__Icon__foreground-action-primary-prominent-idle",
  "foreground-action-success-prominent-high-idle": "web_ui__Icon__foreground-action-success-prominent-high-idle",
  "foreground-action-warning-prominent-high-idle": "web_ui__Icon__foreground-action-warning-prominent-high-idle",
  "foreground-action-warning-prominent-idle": "web_ui__Icon__foreground-action-warning-prominent-idle",
  "foreground-action-error-prominent-high-idle": "web_ui__Icon__foreground-action-error-prominent-high-idle",
  "foreground-action-error-prominent-idle": "web_ui__Icon__foreground-action-error-prominent-idle",
  "foreground-action-neutral-prominent-idle": "web_ui__Icon__foreground-action-neutral-prominent-idle",
  "foreground-action-neutral-static-prominent-idle": "web_ui__Icon__foreground-action-neutral-static-prominent-idle",
  "foreground-action-success-prominent-idle": "web_ui__Icon__foreground-action-success-prominent-idle",
  "foreground-action-neutral-subtle-idle": "web_ui__Icon__foreground-action-neutral-subtle-idle",
  "foreground-action-neutral-inverse-idle": "web_ui__Icon__foreground-action-neutral-inverse-idle",
  "foreground-passive-neutral-inverse": "web_ui__Icon__foreground-passive-neutral-inverse",
  "foreground-passive-neutral-high-idle": "web_ui__Icon__foreground-passive-neutral-high-idle",
  "foreground-passive-neutral-subtle-idle": "web_ui__Icon__foreground-passive-neutral-subtle-idle",
  "foreground-passive-primary-prominent": "web_ui__Icon__foreground-passive-primary-prominent",
  "foreground-passive-success-prominent": "web_ui__Icon__foreground-passive-success-prominent",
  "foreground-passive-warning-prominent": "web_ui__Icon__foreground-passive-warning-prominent",
  "foreground-passive-error-prominent": "web_ui__Icon__foreground-passive-error-prominent",
  "background-action-primary-prominent-idle": "web_ui__Icon__background-action-primary-prominent-idle",
  "background-action-warning-prominent-idle": "web_ui__Icon__background-action-warning-prominent-idle",
  "background-action-success-prominent-idle": "web_ui__Icon__background-action-success-prominent-idle",
  "background-action-error-prominent-idle": "web_ui__Icon__background-action-error-prominent-idle",
  "background-action-neutral-inverse-idle": "web_ui__Icon__background-action-neutral-inverse-idle",
  "background-action-neutral-prominent-idle": "web_ui__Icon__background-action-neutral-prominent-idle",
  "background-action-neutral-subtle-high-idle": "web_ui__Icon__background-action-neutral-subtle-high-idle",
  "background-action-neutral-subtle-idle": "web_ui__Icon__background-action-neutral-subtle-idle",
  "background-action-neutral-subtle-low-idle": "web_ui__Icon__background-action-neutral-subtle-low-idle",
  "background-action-neutral-subtle-low-hover": "web_ui__Icon__background-action-neutral-subtle-low-hover",
  "background-action-neutral-subtle-low-active": "web_ui__Icon__background-action-neutral-subtle-low-active",
  "background-action-neutral-subtle-low-selected": "web_ui__Icon__background-action-neutral-subtle-low-selected",
  "background-passive-primary-prominent-high": "web_ui__Icon__background-passive-primary-prominent-high",
  "background-passive-primary-prominent": "web_ui__Icon__background-passive-primary-prominent",
  "background-passive-primary-subtle-high": "web_ui__Icon__background-passive-primary-subtle-high",
  "background-passive-primary-subtle": "web_ui__Icon__background-passive-primary-subtle",
  "background-passive-warning-prominent": "web_ui__Icon__background-passive-warning-prominent",
  "background-passive-warning-subtle-high": "web_ui__Icon__background-passive-warning-subtle-high",
  "background-passive-warning-subtle": "web_ui__Icon__background-passive-warning-subtle",
  "background-passive-error-prominent": "web_ui__Icon__background-passive-error-prominent",
  "background-passive-error-subtle-high": "web_ui__Icon__background-passive-error-subtle-high",
  "background-passive-error-subtle": "web_ui__Icon__background-passive-error-subtle",
  "background-passive-success-prominent": "web_ui__Icon__background-passive-success-prominent",
  "background-passive-success-subtle-high": "web_ui__Icon__background-passive-success-subtle-high",
  "background-passive-success-subtle": "web_ui__Icon__background-passive-success-subtle",
  "background-passive-neutral-subtle-high": "web_ui__Icon__background-passive-neutral-subtle-high",
  "background-passive-neutral-subtle": "web_ui__Icon__background-passive-neutral-subtle",
  "background-passive-neutral-subtle-low": "web_ui__Icon__background-passive-neutral-subtle-low",
  "background-passive-neutral-prominent-high": "web_ui__Icon__background-passive-neutral-prominent-high",
  "background-passive-neutral-prominent": "web_ui__Icon__background-passive-neutral-prominent",
  "background-passive-neutral-elevation-prominent": "web_ui__Icon__background-passive-neutral-elevation-prominent",
  "background-passive-neutral-elevation-subtle": "web_ui__Icon__background-passive-neutral-elevation-subtle",
  "background-passive-neutral-overlay": "web_ui__Icon__background-passive-neutral-overlay",
  "stroke-action-primary-prominent-high-idle": "web_ui__Icon__stroke-action-primary-prominent-high-idle",
  "stroke-action-primary-prominent-idle": "web_ui__Icon__stroke-action-primary-prominent-idle",
  "stroke-action-warning-prominent-idle": "web_ui__Icon__stroke-action-warning-prominent-idle",
  "stroke-action-success-prominent-idle": "web_ui__Icon__stroke-action-success-prominent-idle",
  "stroke-action-error-prominent-idle": "web_ui__Icon__stroke-action-error-prominent-idle",
  "stroke-action-neutral-prominent-idle": "web_ui__Icon__stroke-action-neutral-prominent-idle",
  "stroke-action-neutral-subtle-high-idle": "web_ui__Icon__stroke-action-neutral-subtle-high-idle",
  "stroke-action-neutral-subtle-idle": "web_ui__Icon__stroke-action-neutral-subtle-idle",
  "stroke-action-neutral-subtle-focused": "web_ui__Icon__stroke-action-neutral-subtle-focused",
  "stroke-action-neutral-subtle-active": "web_ui__Icon__stroke-action-neutral-subtle-active",
  "stroke-action-neutral-subtle-selected": "web_ui__Icon__stroke-action-neutral-subtle-selected",
  "stroke-action-neutral-inverse-idle": "web_ui__Icon__stroke-action-neutral-inverse-idle",
  "stroke-passive-neutral-subtle": "web_ui__Icon__stroke-passive-neutral-subtle",
  "stroke-passive-primary-prominent": "web_ui__Icon__stroke-passive-primary-prominent"
};

var ICON_DISPLAY_VALUES = ['inline-block', 'block'];
/* ---------- Back-compat shims (public API) ---------- */
var ICON_DISPLAY = {
  InlineBlock: 'inline-block',
  Block: 'block'
};
var cssClasses = classNames.bind(styles);
var IconBase = function IconBase(_ref) {
  var name = _ref.name,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? 'inline-block' : _ref$display,
    color = _ref.color,
    title = _ref.title,
    role = _ref.role,
    aria = _ref.aria,
    testId = _ref.testId,
    tabIndex = _ref.tabIndex;
  var iconClass = cssClasses('icon', color, _defineProperty({}, display, display !== 'inline-block'));
  var SvgIcon = name;
  return /*#__PURE__*/jsx("span", {
    className: iconClass,
    "data-testid": testId,
    style: {
      width: SvgIcon.Size ? "".concat(SvgIcon.Size, "px") : undefined
    },
    children: /*#__PURE__*/jsx(SvgIcon, _objectSpread({
      "aria-hidden": true,
      title: title,
      role: role,
      tabIndex: tabIndex
    }, aria))
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Icon = _Object$assign(IconBase, {
  /**
   * @deprecated Use string literals instead: 'inline-block' | 'block'
   */
  Display: ICON_DISPLAY,
  /**
   * @deprecated Use ColorCode constants directly or string literals
   */
  Color: COLOR_CODE
});

export { ICON_DISPLAY, ICON_DISPLAY_VALUES, Icon, Icon as default };
//# sourceMappingURL=Icon.js.map
